import { emit, events } from '@estee/elc-service-bus';

export class StoreDetailsClickedUseCase {
    private id: string;
    private name: string | undefined;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }

    public execute() {
        emit(events.STORE_DETAILS_CLICKED, {
            storeId: this.id,
            storeName: this.name
        });
    }
}
